export function tabDestination(key: string, current: number, count: number, rtl = false): number | undefined {
    if (!count) return undefined;
    if (key === 'Home') return 0;
    if (key === 'End') return count - 1;
    if (key === 'ArrowRight') return (current + (rtl ? -1 : 1) + count) % count;
    if (key === 'ArrowLeft') return (current + (rtl ? 1 : -1) + count) % count;
    return undefined;
}
